import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ideabehind() {
  return (
    <section className="idea_behind p-100 text_second_text">
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="idea_img">
              <StaticImage
                src="../../../images/case-studies/truth-gpt/Project_Description.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={487}
                height={805}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={5}
            xxl={5}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h1>
              Project <span>Description</span>
            </h1>
            <p>
              TruthGPT is an AI-powered mobile app designed to combat
              misinformation by delivering real-time, unbiased information
              through a user-friendly chatbot. With blockchain integration for
              enhanced security and transparency, TruthGPT ensures the accuracy
              of content while providing users with a trustworthy platform.
            </p>
            <p>
              Featuring a unique 3D character, the app engages users through
              interactive conversations, making fact-checking easy and
              accessible.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ideabehind;
